module.exports = __webpack_public_path__ + "static/media/shipping_lifestyle_mobile.72456855.webp";